module.exports = __webpack_public_path__ + "img/2024-ford-super-duty.9c78bab6.png";